import { useRef, useMemo } from 'react';
import { Card, Stack } from '@mui/material';
import { usePageView } from 'src/hooks/use-page-view';
import { useSelection } from 'src/hooks/use-selection';
import ListSearch from 'src/components/ui/search/list-search';
import { ListTable } from './list-table';
import { useTranslation } from 'react-i18next';
import { tokens } from 'src/locales/tokens';
import { appStr } from 'src/locales/app_strings';
import { useRouter } from 'src/hooks/use-router';
import { nextNavigate } from 'src/utils/navigation-utils';
import { paths } from 'src/paths';
import TitleButton from 'src/components/ui/headers/title-button';
import { useGroupHandler } from 'src/hooks/use-group-handler';
import PageSection from 'src/layouts/page-section';
import DropdownDynamic from 'src/components/dropdown/dropdown-dynamic';

const Page = ({ dataSearch, dataStore, dataIds }) => {
  const { t } = useTranslation();
  const rootRef = useRef(null);
  const router = useRouter();
  const itemsSelection = useSelection(dataIds);

  usePageView();

  const labels = useMemo(
    () => ({
      both: { short: 'plate', full: t(appStr.txt_040) },
    }),
    [t]
  );

  const {
    filters,
    filterDefault,
    handleGroupSelection,
    handleSearchHistory,
    handleResetSelection,
  } = useGroupHandler();

  const handleDetail = (item) => {
    nextNavigate(
      router,
      dataSearch.state,
      paths.cars.details,
      paths.cars.index,
      item,
    );
  };

  return (
    <PageSection title="Cars" rootRef={rootRef}>
      <Stack spacing={1}>
        <TitleButton
          label={t(tokens.nav.carManagement)}
          extraContent={
            <DropdownDynamic
              label='Lọc theo xe'
              name='filter_groups'
              items={[
                { label: 'Hiện hữu', value: 'real' },
                { label: 'Lưu lượng', value: 'legal' },
              ]}
              onSelected={handleGroupSelection}
              onReset={handleResetSelection}
              hintValue={filterDefault || ''}
            />
          }
        />
        <Card>
          <ListSearch
            {...({
              triggerSearch: filters,
              onHistory: handleSearchHistory,
            })}
            onFiltersChange={dataSearch.handleFiltersChange}
            filtersQuery={dataSearch.state.filters.query}
            placeholder={'both'}
            filterLabels={labels}
          />
          <ListTable
            dataStore={dataStore}
            onDeselectAll={itemsSelection.handleDeselectAll}
            onDeselectOne={itemsSelection.handleDeselectOne}
            onPageChange={dataSearch.handlePageChange}
            onRowsPerPageChange={dataSearch.handleRowsPerPageChange}
            onSelectAll={itemsSelection.handleSelectAll}
            onSelectOne={itemsSelection.handleSelectOne}
            page={dataSearch.state.page}
            rowsPerPage={dataSearch.state.rowsPerPage}
            selected={itemsSelection.selected}
            onNavigate={dataSearch.handleNavigateChange}
            onDetailClicked={handleDetail}
          />
        </Card>
      </Stack>
    </PageSection>
  );
};

export default Page;
